import React from "react";
import { Box, Button, TextField, Select, MenuItem } from "@mui/material";

const ButtonComponent = ({ component, isEditing, onSave }) => {
  // Aplicar estilos
  const getStyle = () => {
    const style = component.style || {};
    return {
      backgroundColor: style.backgroundColor || "transparent",
      borderRadius: style.borderRadius ? `${style.borderRadius}px` : "4px",
      border: style.borderWidth ? `${style.borderWidth}px solid ${style.borderColor || "#ccc"}` : "1px solid #ccc",
      //   padding: style.padding ? `${style.padding.top || 0}px ${style.padding.right || 0}px ${style.padding.bottom || 0}px ${style.padding.left || 0}px` : '8px',
      padding: "0px",
      margin: style.margin
        ? `${style.margin.top || 0}px ${style.margin.right || 0}px ${style.margin.bottom || 0}px ${style.margin.left || 0}px`
        : "0",
      boxShadow: style.shadow?.enabled
        ? `${style.shadow.offsetX || 0}px ${style.shadow.offsetY || 0}px ${style.shadow.blur || 4}px ${style.shadow.color || "rgba(0,0,0,0.2)"}`
        : "none",
    };
  };

  const getTextStyle = () => {
    const textStyle = component.style?.textStyle || {};
    return {
      fontSize: textStyle.fontSize ? `${textStyle.fontSize}px` : "14px",
      fontWeight: textStyle.fontWeight || "normal",
      color: textStyle.color || "#000000",
      textAlign: textStyle.textAlign || "center",
      fontFamily: textStyle.fontFamily || "inherit",
    };
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...getStyle(),
      }}
    >
      {isEditing ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%" }}>
          <TextField
            defaultValue={component.label}
            variant="outlined"
            size="small"
            onBlur={(e) => onSave({ label: e.target.value })}
            onKeyPress={(e) => e.key === "Enter" && e.target.blur()}
            autoFocus
          />
          <Select defaultValue={component.action} onChange={(e) => onSave({ action: e.target.value })} size="small">
            <MenuItem value="submit">Enviar</MenuItem>
            <MenuItem value="reset">Limpiar</MenuItem>
            <MenuItem value="custom">Personalizado</MenuItem>
          </Select>
        </Box>
      ) : (
        <Button
          variant={component.variant || (component.action === "submit" ? "contained" : "outlined")}
          size={component.size || "medium"}
          disabled={component.disabled}
          fullWidth={component.fullWidth}
          sx={{
            textTransform: "none",
            width: "100%",
            height: "100%",
            "&:hover": {
              backgroundColor: "transparent",
              border: "none",
            },
            ...getTextStyle(),
            ...getStyle(),
          }}
        >
          {component.label}
        </Button>
      )}
    </Box>
  );
};

export default ButtonComponent;
